export default __webpack_public_path__ + "static/media/natwest.e64f7b15.png";